// Layout.tsx
import React from "react";
import Sidebar from "./components/Sidebar/Sidebar";
import Toaster from "./components/Toaster/Toaster";
import Spinner from "./components/Spinner/Spinner";
import './styles/Config.scss'
// Types
interface AdminLayoutProps {
  children: React.ReactNode;
  sideBarLinks?: Array<{ path: string; element: React.ReactNode; label: string }>; 
  isLoginPage?: boolean; 
}

// Render
const AdminLayout: React.FC<AdminLayoutProps> = ({ children, sideBarLinks, isLoginPage }) => {
  return (
  
      <div className="admin-layout">
        <Toaster />
        <Spinner />
        <div className="admin-layout-wrap">
        <div className="admin-main-content">
          {!isLoginPage && <Sidebar links={sideBarLinks} />}
          <div className="admin-content">{children}</div>
        </div>
        
      </div>
    </div>
  );
};

export default AdminLayout;
